export const globalConstants = {
    LOADING: 'loading',
    SUCCEEDED: 'succeeded',
    IDLE: 'idle',
    ERROR: 'error',
    RESET: 'reset'
};